import {
    GET_SALES_RETURN_LIST_PROGRESS, GET_SALES_RETURN_LIST_SUCCESS, GET_SALES_RETURN_LIST_FAILURE,
    ADD_SALES_RETURN_PROGRESS, ADD_SALES_RETURN_SUCCESS, ADD_SALES_RETURN_FAILURE,
    EDIT_DELETE_SALES_RETURN_PROGRESS, EDIT_DELETE_SALES_RETURN_SUCCESS, EDIT_DELETE_SALES_RETURN_FAILURE,
   
    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    salesReturn: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const sales_return_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALES_RETURN_LIST_SUCCESS:
            return { ...state, salesReturn: action.salesReturn, loading: false };
        case GET_SALES_RETURN_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SALES_RETURN_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_SALES_RETURN_PROGRESS:
            return { ...state, loading: true };
        case ADD_SALES_RETURN_SUCCESS:
            return { ...state, salesReturn: [...state.salesReturn, action.payload], loading: false, error: false, message: 'Record saved successfully!' };
        case ADD_SALES_RETURN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to save the record, try again!' };
        case EDIT_DELETE_SALES_RETURN_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_SALES_RETURN_SUCCESS:
            return {
                ...state,
                salesReturn: state.salesReturn.map((salesReturn) =>
                salesReturn._id === action.payload._id ? action.payload : salesReturn
                ),
                message: action.payload.is_deleted === 1 ? 'Record deleted successfully!' : 'Record updated successfully!'
            };
        case EDIT_DELETE_SALES_RETURN_FAILURE:
            return { ...state, loading: false, error: action.payload, message: 'Failed to update the record, try again!' };
     
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message

        default:
            return state
    }
}

export default sales_return_reducer;